import React from "react";

import API from "@beardeddevops/react.api";
import Framework from "@beardeddevops/react.framework";
import {Parts, Elements, Types, Objects, Collections} from "components";

import {Alert, Button, ButtonGroup} from "reactstrap";
import Tooltip from "@material-ui/core/Tooltip";
import {confirmAlert} from 'react-confirm-alert';
import {PrintBarcodeModal} from '../../containers/Print';
import ProductLong from "components/Labels/ProductLong";
import ProductShort from "components/Labels/ProductShort";
import TransactionObject from "components/TransactionObject";
import UniversalModalOverride from "components/UniversalModalOverride";
import moment from "moment";
import {isEmpty} from "lodash";
import {ListItemText} from "@material-ui/core";
import MenuItem from "@material-ui/core/MenuItem";


/**
 * @property {Transactions_Collections_Object} state
 * @property {object} model
 * @property {Transactions_Collections_Properties} model.properties
 * @property {Transactions_Collections_Is} model.is
 * @property {Transactions_Collections_Has} model.has
 */
class AcquisitionObject extends TransactionObject {
	constructor(props) {
		super(props, Types.Transactions_Collections._name);
		// this.loadProductTypes().then();
		this.read = 'GET_ACQUISITION';
		this.update = typeof props.id !== 'undefined' && props.id ? 'POST_ACQUISITION' : 'PUT_ACQUISITION';
		this.state.acquired_from = typeof props.id !== 'undefined' && props.id !== null ? '' : 'dealer';
		this.delete = 'DELETE_ACQUISITION';

		this.state.has_pawn_module = props.rootState.hasPawnModule;
		this.state.keepOpen = false
		this.state.modalFormSix = false;
		// this.state.modalCsv = false;

		this.afterEventSave = this.setNewObject('event');
		this.afterCustomerSave = this.setNewObject('customer');
		this.afterDealerSave = this.setNewObject('dealer');
		this.afterImporterSave = this.setNewObject('importer');

		this.bulkAddName = "Bulk Products";
		this.state.additionalButtons = null;
		this.state.product_types = [];
		this.state.productErrorObj = {};
	}

	/**
	 *
	 */
	async componentDidMount() {
		super.componentDidMount();
		if(this.props.transaction_entries) {
			let transaction_entriess = [];
			for (let entry of this.props.transaction_entries) {
				transaction_entriess.push({
					pawn_redemption: false,
					pawn_redemption_error: "",
					product: entry.pkey,
					product_binary_id: entry.binary_id,
					products: entry
				});
			}
			this.setState({transaction_entriess});
			this.validProducts(transaction_entriess);
		}

		if(this.props.order_id) {
			this.setState({foreign_order_id: this.props.order_id});
		}

	}

	/**
	 * @param prevProps
	 * @param {Transactions_Collections_Object} prevState
	 * @param snapshot
	 */
	componentDidUpdate(prevProps, prevState, snapshot) {
		super.componentDidUpdate(prevProps, prevState, snapshot);
		// noinspection JSValidateTypes
		/** @type {Transactions_Collections_Object} object */
		let object = this.state;

		// flag to track if a significant change has occurred
		let unsavedData = false;

		if (typeof this.props.updateName === 'function') {
			// this.validProducts(this.state.transaction_entriess)
			this.props.updateName(object.transaction || object.pkey);
		}

		//toggle P12 form
		if(prevProps.toggleForm !== this.props.toggleForm){
			this.setState({formP12: true});
		}

		// if(this.props.transaction_entries) {
		// 	for(let i = 0; i < this.props.transaction_entries.length; i++) {
		// 		console.log('inside here', this);
		// 		if(this.props.transaction_entries[i].manufacturer !== this.state.transaction_entriess[i].products.manufacturer) {
		// 			this.validProducts(this.state.transaction_entriess)
		// 			// unsavedData = true;
		// 			break;
		// 		}
		// 	}
		// }

		//If Pkey has always been blank || this isn't the initial load so pkey is the same
		if (prevState.pkey === object.pkey || prevState.binary_id === object.binary_id) {
			//Then check related props
			//If "Internal" select was updated, update corresponding Dealer Information
			if (object.locations_related_by_internal && object.internal !== prevState.internal) {
				unsavedData = true;
				this.setState({
					'dealer_name_company': object.internal ? object.locations_related_by_internal.name_display || object.locations_related_by_internal.name : '',
					'dealer_ffl': object.internal ? object.locations_related_by_internal.ffl : ''
				});
			}
			//If "Dealer" select was updated, update corresponding Dealer Information
			if (object.dealers && (object.dealer !== prevState.dealer || object.dealers !== prevState.dealers)) {
				unsavedData = true;
				this.setState({
					'dealer_name_company': object.dealer ? object.dealers.name_display || object.dealers.name_company : '',
					'dealer_ffl': object.dealer ? object.dealers.ffl : '',
					'dealer_name_trade': object.dealer ? object.dealers.name_trade : ''
				});
			}
			//If "Importer" select was updated, update corresponding Importer Information
			if (object.importers && object.importer !== prevState.importer) {
				unsavedData = true;
				this.setState({
					'importer_name_display' : object.importer ? object.importers.name : '',
					'importer_ffl': object.importer ? object.importers.ffl : '',
					'importer_full_address': object.importer ? object.importers.full_address : ''
				})
			}
			//If "Customer" select was updated, update corresponding Customer Information
			if (object.customers && object.customer !== prevState.customer && object.customers.customer_addressess) {
				unsavedData = true;
				this.setState({
					'customer_name_first': object.customer ? object.customers.name_first : '',
					'customer_name_middle': object.customer ? object.customers.name_middle : '',
					'customer_name_last': object.customer ? object.customers.name_last : '',
					'customer_name_suffix': object.customer ? object.customers.name_suffix : '',
					'customer_street_1': object.customer && object.customers.customer_addressess.length > 0 ? object.customers.customer_addressess[0].street_1 : '',
					'customer_street_2': object.customer && object.customers.customer_addressess.length > 0 ? object.customers.customer_addressess[0].street_2 : '',
					'customer_city': object.customer && object.customers.customer_addressess.length > 0 ? object.customers.customer_addressess[0].city : '',
					'customer_county': object.customer && object.customers.customer_addressess.length > 0 ? object.customers.customer_addressess[0].county : '',
					'customer_state': object.customer && object.customers.customer_addressess.length > 0 ? object.customers.customer_addressess[0].state : '',
					'customer_zip': object.customer && object.customers.customer_addressess.length > 0 ? object.customers.customer_addressess[0].zip : '',
				});
			}

			//if you edit the customer
			if(object.customers && object.customers !== prevState.customers) {
				this.setState({
					customer_name_first: object.customers.name_first,
					customer_name_middle: object.customers.name_middle,
					customer_name_last: object.customers.name_last,
					customer_name_suffix: object.customers.name_suffix,
				})
			}

			//If "Location" select was updated, update corresponding Location Information
			if (object.locations_related_by_location && object.location !== prevState.location && prevState.location !== "" && prevState.location !== null) {
				unsavedData = true;
				this.setState({'bound_book': ''});
			}

		}
		if (unsavedData && this.props.hasModal) {
			this.validProducts(this.state.transaction_entriess)
			if (typeof(this.props.setBackdrop) === 'function') {
				this.props.setBackdrop('static')
			}
		}



	}


	loadProductTypes = async () => {
		let typeModel = new API.BuildClass(Types.Products_Types._name, API.RequestType.READ_ALL);
		typeModel.limit = 20;
		let types = await typeModel.submit(null, API.RequestType.READ_ALL);

		this.setState({product_types: types.items});
	}

	// noinspection JSUnusedGlobalSymbols
	/**
	 * @param {Transactions_Collections_Object} data
	 */
	loadSelfAfter(data) {
		if (data.internal != null) {
			this.setState({'acquired_from': 'internal'});
		} else if (data.dealer != null) {
			this.setState({'acquired_from': 'dealer'});
		} else if (data.customer != null) {
			this.setState({'acquired_from': 'customer'});
		} else if (data.importer != null) {
			this.setState({'acquired_from': 'importer'})
		}

		if (data.pawn_inventory || data.pawn_ticket) {
			this.setState({'has_pawn_module': true});
		}

		if (typeof this.props.updateName === 'function') {
			this.props.updateName(data.transaction || (data.binary_id + '-' + data.pkey));
		}
	};

	/**
	 * Override to add custom validations in Objects
	 * STEP: Add Function
	 * STEP: Bind to THIS in constructor
	 *
	 * @param event
	 * @param requestOverride
	 * @returns {boolean|*}
	 */
	handleProcess(event, requestOverride) {
		let result = true;
		if ((this.state.transaction_entriess === null || this.state.transaction_entriess.length === 0) && this.state.pkey === null) {
			API.Toast.warn('A product is required.', {
				position: API.Toast.POSITION.TOP_CENTER,
				autoClose: 4000
			});
			result = false;
		}

		if (!this.state.customer && !this.state.dealer && !this.state.importer && this.state.acquired_from !== 'internal') {
			this.setState({
				customer_error: 'Customer is required',
				dealer_error: 'Dealer is required',
				importer_error: 'Importer is required'
			})
			result = false;
		}

		if(!this.state.date) {
			this.setState({
				date_error: 'Date is required'
			})
			result = false;
		}
		//If either is false then fail
		return result && super.handleProcess(event, requestOverride);
	}

	async handleSubmit(event, suppressToast = false) {
		// FIXME: don't mutate state.
		// TODO: We want to update state here without triggering a state update. Any other ides would be welcome - JW
		if(this.props.order_id) {
			this.state.foreign_order_id = this.props.order_id;
		}
		this.state.products = this.state.transaction_entriess.map(entry => entry.products.binary_id + '-' + entry.products.pkey);
		if (typeof(this.props.setBypass) === 'function') {
			this.props.setBypass(true);
		}
		await super.handleSubmit(event, suppressToast);
		// this.props.history.push("/");
		// this.props.history.push("/acquisitions");
	};

	printLabel = (e) => {
		const {transaction_entriess} = this.state;
		let pkey = e.currentTarget.id;
		let longBarCode, shortBarCode;

		switch (pkey) {
			case 'all':
				longBarCode = transaction_entriess.map((entry, key) => <ProductLong key={key} product={entry.products} acquisition={this.state.transaction}/>)
				shortBarCode = transaction_entriess.map((entry, key) => <ProductShort key={key} product={entry.products}/>)
				break;
			default: {
				return;
			}
		}

		confirmAlert({
			customUI: ({onClose}) => {
				return (
					<PrintBarcodeModal
						onClose={onClose}
						longBarCode={longBarCode}
						shortBarCode={shortBarCode}
						showFullLabel={true}
					/>
				);
			}
		});
	};

	handleSetKeepOpen = (x= false) => {
		this.setState({ keepOpen: x })
	}



	handleReportCsvClose = () => {
		// console.log('trying to close modal', this);
		this.setState({
			modalCsv: !this.state.modalCsv
		})
		// console.log('trying to close modal', this);

	}

	addCsvProducts = () => {
		this.setState({
			modalCsv: !this.state.modalCsv
		})
		// console.log('in here', this);
	}

	deleteAllProducts = () => {
		if(this.state._id === '') {
			this.setState({transaction_entriess: []})
		}
		else {
			confirmAlert({
				title: "Confirm Delete All",
				message: typeof this.delete_message !== 'undefined' ? this.delete_message : 'Are you sure you want to delete all items from this transfer?',
				buttons: [
					{
						label: 'Yes',
						onClick: async () => {
							this.model = new API.BuildClass(Types.Transactions_Entries._name, 'DELETE');
							this.model.parent = this.state.pkey;
							await this.model.submit(null, 'DELETE_ALL').then(() => {
								window.location.reload();
								// this.setState({transaction_entriess: []});
							});
						}
					},
					{
						label: 'No',
						onClick: () => {
						}
					}
				]
			});
		}
	};

	handleAdditionalButtons = (button) => {
		this.setState({additionalButtons: button})
	}

	validProducts = (transaction_entriess) => {
		this.setState({productErrorMsg: []})
		let validType = true;
		let initialMsg = '';
		let productErrorObj = {};
		for(let product of transaction_entriess) {
			let validProduct = true;
			let productErrorMsg = [];
			// validType = (this.state.product_types.find(type => type.name === product.products.type ))
			if(product.products.caliber === null && product.products.caliber_other === null)
			{
				productErrorMsg.push('caliber');
				validProduct = false;
			}
			if(product.products.manufacturer === null && product.products.manufacturer_other === null)
			{
				productErrorMsg.push('manufacturer');
				validProduct = false;
			}
			if (product.products.type === null)
			{
				productErrorMsg.push('type');
				validProduct = false;
			}
			if(product.products.serial_number === null)
			{
				productErrorMsg.push('serial_number');
				validProduct = false;
			}
			if(product.products.model === null)
			{
				productErrorMsg.push('model');
				validProduct = false;
			}
			if(!validProduct) {
				productErrorMsg = productErrorMsg.toString();
				productErrorObj[product.products.serial_number] = {productErrorMsg};
			}
		}


		this.setState({productErrorObj})
		let error_msg = '';
		const productCount = Object.keys(productErrorObj).length;
		let errorMessages = [];
		if(productCount > 0 ) {
		// error_msg = "WARNING: The following products are missing required fields: \n ";
		for (const [key, value] of Object.entries(productErrorObj)) {
			errorMessages.push({
				productKey: key,
				message: `${key} is missing the following fields: ${value['productErrorMsg']} [CLICK_TO_EDIT]`
			});
		}
			this.setState({productErrorObj})
			this.setState({productErrorMsg: errorMessages})
		}

	}


	// kendallRename = async (product, newEntry = null, force = false) => {
	// 	this.updateProduct(product, newEntry, force);
	// 	await this.validProducts(this.state.transaction_entriess)
	// };




	form = () => {
		let {rootState} = this.props;
		let {hasPawnModule, hasImporterModule} = rootState;
		/** @type {Transactions_Collections_Properties} object */
		let properties = this.model.properties;
		/** @type {Transactions_Collections_Object} object */
		let object = this.state;
		let {loading} = this.state;
		let isNew = this.state._id === '';

		return (
			<div>
				<fieldset>
					{/*{this.state.productErrorMsg  && <Alert color="danger" style={{ whiteSpace: 'pre-line'}} onClick={this.handleToggleProductModel('productUpdate' + 0)}>*/}
					{/*	{this.state.productErrorMsg} Click me to edit the product*/}
					{/*</Alert>}*/}
					{this?.state?.productErrorMsg?.length > 0 && <Alert color="danger">
						<div>WARNING: The following product(s) are missing required fields:</div>
						{this.state.productErrorMsg.map((error, index) => (
							<div
								key={index}
								onClick={this.handleToggleProductModel('productUpdate' + index)}
								style={{
									cursor: 'pointer',
									padding: '5px 0',
									whiteSpace: 'pre-line'
								}}
							>
								{error.message}
							</div>
						))}
					</Alert>}

					<div className={"row"}>
						<div className={"col-md"}>
							<h4 className="section-title">Details</h4>
							<Parts.SelectLocation
								object={object}
								properties={properties}
								shouldLoad={this.state.loaded}
								onSelectUpdate={this.handleSelectPropertyUpdate}
								locations={this.props.locations}
								states={this.props.states}
								filter={this.filterLocationOptions}
							/>
							{object.locations_related_by_location ?
								<Parts.SelectBoundBook
									object={object}
									properties={properties}
									shouldLoad={this.state.loaded}
									onSelectUpdate={this.handleSelectPropertyUpdate}
								/> : null}
							<Parts.TransactionDetails
								history={this.props.history}
								locations={this.props.locations}
								states={this.props.states}
								object={object}
								properties={properties}
								shouldLoad={this.state.loaded}
								onTextUpdate={this.handleTextFieldPropertyUpdate}
								onSelectUpdate={this.handleSelectPropertyUpdate}
								afterEventSave={this.afterEventSave}
								isNew={isNew}
							/>

							{this.state.has_pawn_module || hasPawnModule ?
								<div>
									<h4 className="section-title">Pawn Inventory</h4>
									<div className="row">
										<div className={"col-xl"}>
											<Framework.Elements.TextField
												property={properties.pawn_inventory}
												value={object.pawn_inventory}
												error={object.pawn_inventory_error}
												update={this.handleTextFieldPropertyUpdate}
											/>
										</div>
										<div className={"col-xl"}>
											<Framework.Elements.TextField
												property={properties.pawn_ticket}
												value={object.pawn_ticket}
												error={object.pawn_ticket_error}
												update={this.handleTextFieldPropertyUpdate}
											/>
										</div>
									</div>
								</div> : null}

						</div>
						<div className={"col-md"}>
							<h4 className="section-title">Importer / Customer / Dealer</h4>
							<div className={'form-group'}>
								<div className="row">
									<div className="col-sm-auto">
										<span className="input-label">Acquired From</span>
									</div>
									<div className="col-sm text-right">
										<ButtonGroup>
											{hasImporterModule &&
											<Button data-id={'acquired-importer'} color={"primary"}
				                              outline={this.state.acquired_from !== 'importer'}
				                              onClick={() => {
					                              this.setState({
						                              'dealer': '',
						                              'customer': '',
						                              acquired_from: 'importer',
					                              })
				                              }}
				                              disabled={this.state.acquired_from === 'internal'}
				                              active={this.state.acquired_from === 'importer'}>Importer</Button>
											}
											<Button data-id={'acquired-customer'} color={"primary"}
											        outline={this.state.acquired_from !== 'customer'}
											        onClick={() => {
												        this.setState({
													        'dealer': '',
													        acquired_from: 'customer',
													        'importer': '',
												        })
											        }}
											        disabled={this.state.acquired_from === 'internal'}
											        active={this.state.acquired_from === 'customer'}>Customer</Button>

											<Button data-id={'acquired-dealer'} color={"primary"}
											        outline={this.state.acquired_from !== 'dealer'}
											        onClick={() => {
												        this.setState({
													        'customer': '',
													        acquired_from: 'dealer',
													        'importer': '',
												        })
											        }}
											        disabled={this.state.acquired_from === 'internal'}
											        active={this.state.acquired_from === 'dealer'}>Dealer</Button>

											{/*TODO: Is internal being used in the modal*/}
											{object.internal ?
												<Button data-id={'acquired-self'} color={"primary"}
												        onClick={() => {
												        }}
												        outline={this.state.acquired_from !== 'internal'}
												        active={this.state.acquired_from === 'internal'}>From Self</Button>
												: null}
										</ButtonGroup>
									</div>
								</div>
							</div>

							{this.state.acquired_from === 'customer' &&
							<Parts.TransactionCustomer
								locations={this.props.locations}
								states={this.props.states}
								object={object}
								properties={properties}
								shouldLoad={this.state.loaded}
								history={this.props.history}
								onTextUpdate={this.handleTextFieldPropertyUpdate}
								onSelectUpdate={this.handleSelectPropertyUpdate}
								afterCustomerSave={this.afterCustomerSave}
								disableFields={true}
								data-cy={"modalCustomerDropdown"}
							/>}

							{this.state.acquired_from === 'dealer' &&
							<Parts.TransactionDealer
								locations={this.props.locations}
								states={this.props.states}
								object={object}
								properties={properties}
								shouldLoad={this.state.loaded}
								history={this.props.history}
								onTextUpdate={this.handleTextFieldPropertyUpdate}
								onSelectUpdate={this.handleSelectPropertyUpdate}
								afterDealerSave={this.afterDealerSave}
								disableFields={true}
							/>}

							{this.state.acquired_from === 'importer' &&
							<Parts.TransactionImporter
								locations={this.props.locations}
								states={this.props.states}
								object={object}
								properties={properties}
								shouldLoad={this.state.loaded}
								history={this.props.history}
								onTextUpdate={this.handleTextFieldPropertyUpdate}
								onSelectUpdate={this.handleSelectPropertyUpdate}
								afterImporterSave={this.afterImporterSave}
								disableFields={true}
							/>}

							{this.state.acquired_from === 'internal' &&
							<Parts.TransactionInternal
								locations={this.props.locations}
								states={this.props.states}
								object={object}
								properties={properties}
								shouldLoad={this.state.loaded}
								onTextUpdate={this.handleTextFieldPropertyUpdate}
								onSelectUpdate={this.handleSelectPropertyUpdate}
							/>}

						</div>
						<div className={"col-md"}>
							<div className="section-title">
								<h4 className="section-title">Items</h4>
								<div className="button-container">
									{object.pkey && object.transaction_entriess &&
									<Button id="all" onClick={this.printLabel} size={"sm"}
									        color="default">
										Print Product Labels
									</Button>}
									<Tooltip title="New products that you have never acquired are added here."
									         aria-label="New products that you have never acquired are added here.">
										<Button data-id="add-product" onClick={this.handleToggleModalAdd} size={"sm"}
										        color="primary">
											<i className={"fa fa-plus"} data-cy={"new-acquisition-button"}/>
											<span className="hidden-xs">&nbsp;&nbsp;New</span>
										</Button>
									</Tooltip>
									<Tooltip
										title="Products you have previously acquired and disposed / transferred can be found here."
										aria-label="Products you have previously acquired and disposed / transferred can be found here.">
										<Button data-id="previous-product" onClick={this.handleToggleModalLookup} size={"sm"}
										        color="primary">
											<i className={"fa fa-barcode"}/>
											<span className="hidden-xs">&nbsp;&nbsp;Previous</span>
										</Button>
									</Tooltip>

									<Tooltip
										title="Bulk Add Products"
										aria-label="Bulk Add Products">
										<Button data-id="previous-product" onClick={this.handleToggleModalCsv} size={"sm"}
										        color="primary">
											<i className={"fa fa-copy"}/>
											<span className="hidden-xs">&nbsp;&nbsp;Bulk Add</span>
										</Button>
									</Tooltip>

									{(this.props.userAccess === 0 || 10) && (object.transaction_entriess.length >= 10) &&
										<Button onClick={this.deleteAllProducts} size={'sm'} color='danger'>
											<i className={"fa fa-trash-o"}/>
											<span className='hidden-xs'>&nbsp;&nbsp;Delete All</span>
										</Button>
									}
								</div>
							</div>

							<div style={{
								overflowY: "auto",
								paddingRight: "4px",
								maxHeight: "362px"
							}}>
								{object.transaction_entriess && object.transaction_entriess.map((entry, i) =>
									<Elements.Item
										key={i}
										entry={entry}
										product={entry.products}
										onDelete={this.deleteProduct}
										onUpdate={this.updateProduct}
										openModal={this.handleToggleProductModel('productUpdate' + i)}
										reportClose={this.handleReportModalClose('productUpdate' + i)}
										modalUpdate={this.state['productUpdate' + i]}
										history={this.props.history}
										locations={this.props.locations}
										states={this.props.states}
										locationManufacturer={object.dealer_name_company}
									/>)}
								<p style={{textAlign: 'center', color: 'grey'}}><i>{object.transaction_entriess.length} Total Items</i></p>
							</div>

						</div>
					</div>
					<hr/>
					<span style={{color: "lightgray"}}>Created: {object.creator ? object.users_related_by_creator : this.props.rootState.account} &nbsp;
						{object.created ? moment(object.created).local().format('YYYY-MM-DD HH:mm:ss') : null} &nbsp;</span>
					{object.modifier &&
					<span style={{color: "lightgray"}}>|&nbsp; Modified: {object.modifier ? object.users_related_by_modifier : this.props.rootState.account} &nbsp;
						{moment(object.modified).local().format('YYYY-MM-DD HH:mm:ss')}</span>
					}
				</fieldset>

				{this.state.created && this.state.importer &&
					 <Button data-id="previous-product" onClick={this.toggle('modalForm3A')} size={"sm"}
				                               color="info">
					<i className={"fa fa-barcode"}/>
					<span className="hidden-xs">&nbsp;&nbsp;Generate Form 6A</span>
				</Button>}

				{this.state.created && this.state.importer && 
					<Button data-id="previous-product" onClick={this.toggle('modalForm3C')} size={"sm"}
					color="info">
					<i className={"fa fa-barcode"}/>
					<span className="hidden-xs">&nbsp;&nbsp;Generate Form 6C</span>
					</Button>
				}

				<Framework.Elements.LoadingSpinner isLoading={loading}/>

				<UniversalModalOverride
					locations={this.props.locations}
					states={this.props.states}
					history={this.props.history}
					name={"Product"}
					object={Objects.ProductAdd}
					toggle={this.state.modalAdd}
					reportClose={this.handleReportProductClose}
					keepOpen = {this.state.keepOpen}
					afterSave={this.addProducts}
					size={"xl"}
					objectProps={{scannedCode: this.state.modalAdd ? this.props.scannedCode : null,setKeepOpen:this.handleSetKeepOpen,keepOpen:this.state.keepOpen, locationHasRIModule: this.state.locations_related_by_location.has_michigan_module }}
					setKeepOpen ={this.handleSetKeepOpen}
				/>

				<UniversalModalOverride
					locations={this.props.locations}
					states={this.props.states}
					history={this.props.history}
					name={"Previous Products"}
					object={Collections.ProductsExisting}
					toggle={this.state.modalLookup}
					reportClose={this.handleReportProductClose}
					afterSave={this.addProducts}
					size={"xl"}
					status={"GET_OUT_OF_STOCK"}
					objectProps={{scannedCode: this.state.modalLookup ? this.props.scannedCode : null}}
				/>


				<UniversalModalOverride
					locations={this.props.locations}
					states={this.props.states}
					history={this.props.history}
					name={this.bulkAddName}
					object={Objects.ProductAddCsv}
					toggle={this.state.modalCsv}
					reportClose={this.handleReportProductClose}
					afterSave={this.addProducts}
					size={"xl"}
					submitLabel={"Add Bulk Products"}
					objectProps={{addAdditionalButtons: this.handleAdditionalButtons}}
					additionalButtons={this.state.additionalButtons}
				/>

				<UniversalModalOverride
					locations={this.props.locations}
					states={this.props.states}
					history={this.props.history}
					title={"ATF Form (5330.3A) 6"}
					name={'ATF Form (5330.3A) '}
					object={Objects.FormSix3A}
					toggle={this.state['modalForm3A']}
					reportClose={this.reportClose('modalForm3A')}
					size={'xl'}
					submitLabel={"Generate Form (5330.3A)"}
					objectProps={{'importer': this.state.importers, 'collection': this.state.pkey, 'collection_binary_id': this.state.binary_id}}
				/>

				<UniversalModalOverride
					locations={this.props.locations}
					states={this.props.states}
					history={this.props.history}
					name={"ATF Form (5330.3A)"}
					title={"ATF Form (5330.3C) 6"}
					object={Objects.FormSix3C}
					toggle={this.state['modalForm3C']}
					reportClose={this.reportClose('modalForm3C')}
					size={'xl'}
					submitLabel={"Generate Form (5330.3C)"}
					objectProps={{'importer': this.state.importers, 'collection': this.state.pkey, 'collection_binary_id': this.state.binary_id}}
				/>

				<UniversalModalOverride
					locations={this.props.locations}
					states={this.props.states}
					name={"New York P12 Form"}
					title={"New York P12 Form"}
					object={Objects.FormP12}
					history={this.props.history}
					toggle={this.state['formP12']}
					reportClose={this.reportClose('formP12')}
					afterSave={() => this.props.generatedForm()}
					url="dispositions"
					size="xl"
					objectProps ={{
						products: this.state.transaction_entriess,
						transaction_date: this.state.date,
						collection: this.props.id,
						acq_state: this.state,
						customer_permit: this.state?.customer_permits ? this.state.customer_permits[0] : null
					}}
					submitLabel={"Generate P12 Form"}

				/>

			</div>
		)
	};
}

export default Framework.Components.withRootState(AcquisitionObject);
